import lazyLoading from './lazyLoading'

export default {
  name: 'Change Risk Dashboard',
  meta: {
    icon: 'fa-pie-chart',
    expanded: true
  },

  children: [
    {
      name: 'My Change Risk Report',
      path: '/assessment/myReport',
      component: lazyLoading('assessment/myReport'),
      meta: {
        icon: 'fa fa-line-chart',
        link: 'assessment/myReport'
      }
    },
    {
      name: 'Risks by Team Average',
      path: '/assessment/teamReportByAverage',
      component: lazyLoading('assessment/teamReportByAverage'),
      meta: {
        icon: 'fa fa-area-chart',
        link: 'assessment/teamReportByAverage'
      }
    },
    {
      name: 'Risks by Team Variance',
      path: '/assessment/teamReportByVariance',
      component: lazyLoading('assessment/teamReportByVariance'),
      meta: {
        icon: 'fa fa-bar-chart',
        link: 'assessment/teamReportByVariance'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/reports.js